export const MAP_ENTITY_ICONS = {
  marker: "fi fi-rr-marker",
  polygon: "fi fi-rr-draw-polygon",
  polyline: "fi fi-rr-route",
  circle: "fi fi-rr-circle",
  customIcon: "fi fi-rr-thumbtack",
};

/**
 * User-facing names. Internal types (Polygon, Polyline, REGION, Google APIs) stay unchanged.
 * Freeform Polygon/Polyline → Area/Chain. ADM REGION / search Boundary stay Region/Boundary.
 * CustomIcon → Pin.
 */
export const MAP_ENTITY_TYPE_LABELS = {
  marker: "Marker",
  polygon: "Area",
  polyline: "Chain",
  circle: "Circle",
  customicon: "Pin",
  region: "Region",
  boundary: "Boundary",
};

const ENTITY_TYPE_ICON_BY_KEY = {
  marker: MAP_ENTITY_ICONS.marker,
  polygon: MAP_ENTITY_ICONS.polygon,
  polyline: MAP_ENTITY_ICONS.polyline,
  circle: MAP_ENTITY_ICONS.circle,
  customicon: MAP_ENTITY_ICONS.customIcon,
  custom_icon: MAP_ENTITY_ICONS.customIcon,
  region: MAP_ENTITY_ICONS.polygon,
  boundary: MAP_ENTITY_ICONS.polyline,
};

const normalizeEntityTypeKey = (entityType) => {
  const raw = String(entityType || "").trim();
  if (!raw) return "";
  const compact = raw.toLowerCase().replace(/\s+/g, "");
  if (compact === "customicon" || compact === "custom_icon") return "customicon";
  return compact;
};

export const getMapEntityTypeLabel = (entityType, { lowercase = false } = {}) => {
  const key = normalizeEntityTypeKey(entityType);
  const label =
    MAP_ENTITY_TYPE_LABELS[key] ||
    (key === "customicon" ? MAP_ENTITY_TYPE_LABELS.customicon : "") ||
    String(entityType || "").trim() ||
    "Unknown type";
  return lowercase ? label.toLowerCase() : label;
};

export const getNewEntityTitle = (entityType) =>
  `New ${getMapEntityTypeLabel(entityType)}`;

export const getAddEntityPanelTitle = (entityType) =>
  `Add ${getMapEntityTypeLabel(entityType)}`;

/**
 * Resolve toolbar-matching icon + accessible label for a map entity type.
 * Returns null icon when type is unknown (caller can fall back to text).
 */
export const getMapEntityTypeVisual = (entityType, preferredLabel) => {
  const raw = String(entityType || "").trim();
  const key = normalizeEntityTypeKey(raw);
  const iconClass = ENTITY_TYPE_ICON_BY_KEY[key] || null;
  const label =
    (preferredLabel && String(preferredLabel).trim()) ||
    getMapEntityTypeLabel(raw) ||
    "Unknown type";

  return { iconClass, label };
};
